import { useState } from 'react'
import { Link } from 'react-router-dom'
import { PRICING } from '../data/demo'
import { Page } from '../components/Layout'
import { EarlyAccessForm, useModal } from '../components/ui'

export function PricingPage() {
  const [annual, setAnnual] = useState(true)
  const modal = useModal()
  const discount = PRICING.annualDiscount

  return (
    <Page>
      <div className="app-header">
        <div>
          <div className="kicker">
            <span className="pulse" aria-hidden />
            Concept pricing
          </div>
          <h1 className="display" style={{ fontSize: 'clamp(2rem,4vw,3rem)' }}>
            Pay for truth infrastructure — not chart wallpaper.
          </h1>
          <p className="muted" style={{ maxWidth: 560 }}>
            Every plan includes the same verification philosophy. Higher tiers unlock account count, portfolio
            rollup, teams, and export concepts.
          </p>
        </div>
      </div>

      <div className="notice warn">{PRICING.disclosure}</div>

      <div style={{ display: 'flex', justifyContent: 'center', margin: '1.25rem 0 1.5rem' }}>
        <div className="seg" role="group" aria-label="Billing period">
          <button type="button" aria-pressed={!annual} onClick={() => setAnnual(false)}>
            Monthly
          </button>
          <button type="button" aria-pressed={annual} onClick={() => setAnnual(true)}>
            Yearly · save {Math.round(discount * 100)}%
          </button>
        </div>
      </div>

      <div className="pricing-grid">
        {PRICING.plans.map((p) => {
          const price = annual && p.monthly > 0 ? Math.round(p.monthly * (1 - discount)) : p.monthly
          const yearlyTotal = annual && p.monthly > 0 ? price * 12 : null
          return (
            <article key={p.id} className={`card price-card ${p.featured ? 'featured' : ''}`}>
              {p.featured ? <div className="badge verified">Best value concept</div> : <div className="badge">Tier</div>}
              <h3>{p.name}</h3>
              <div className="price">
                ${price}
                <span>/{annual ? 'mo billed yearly' : 'mo'}</span>
              </div>
              {yearlyTotal != null ? (
                <div className="mute mono" style={{ fontSize: '0.85rem' }}>
                  ${yearlyTotal}/yr effective · was ${p.monthly * 12}
                </div>
              ) : (
                <div className="mute mono" style={{ fontSize: '0.85rem' }}>
                  {p.monthly === 0 ? 'No card · concept free tier' : 'Monthly concept'}
                </div>
              )}
              <p className="muted" style={{ margin: 0 }}>
                {p.blurb}
              </p>
              <ul>
                {p.features.map((f) => (
                  <li key={f}>{f}</li>
                ))}
              </ul>
              {p.id === 'business' ? (
                <button
                  type="button"
                  className="btn btn-amber btn-block"
                  onClick={() => modal.open(<EarlyAccessForm />, { title: 'Business early access' })}
                >
                  {p.cta}
                </button>
              ) : (
                <Link to="/dashboard" className={`btn ${p.featured ? 'btn-primary' : 'btn-secondary'} btn-block`}>
                  {p.cta}
                </Link>
              )}
            </article>
          )
        })}
      </div>

      <div className="card card-pad" style={{ marginTop: '2rem' }}>
        <h2 className="display" style={{ marginTop: 0, fontSize: '1.4rem' }}>
          What you are actually buying
        </h2>
        <div className="split-3">
          <div>
            <strong className="lime">Verification labor</strong>
            <p className="muted">Freshness, D/W reconciliation, public methodology.</p>
          </div>
          <div>
            <strong className="amber">Risk physics</strong>
            <p className="muted">Budgets and breach visibility before the post-mortem.</p>
          </div>
          <div>
            <strong>Behavior signal</strong>
            <p className="muted">Journal scores that make revenge expensive to ignore.</p>
          </div>
        </div>
        <div className="hero-actions" style={{ marginTop: '1rem' }}>
          <Link to="/dashboard" className="btn btn-primary">
            Explore demo without paying
          </Link>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => modal.open(<EarlyAccessForm />, { title: 'Early access' })}
          >
            Join early access
          </button>
        </div>
      </div>
    </Page>
  )
}
